import Analyses from "api/lib/data/Analyses";
import * as React from "react";
import { Button } from "semantic-ui-react";
import { Base, ResourceType } from "src/components/Common/Base";
import ListBase, {
  IListBaseProps,
  IListBaseState,
} from "../../components/Common/ListBase";
import * as routes from "../../constants/routes";
import { AnalysisForm } from "./AnalysisForm";

export interface IAnalysesProps extends IListBaseProps {
  history: any;
}

export interface IAnalysesState extends IListBaseState {
  nothing: any;
}
export default class AnalysesTable extends ListBase<
  IAnalysesProps,
  IAnalysesState
> {
  constructor(props: IAnalysesProps) {
    super(props, new Analyses(props.orgId));
    this.state = {
      ...ListBase.LIST_BASE_INITAL_STATE,
      nothing: null,
      resourceType: Base.RESOURCE_LABEL[ResourceType.analysis],
      columns: [
        {
          name: "name",
          header: "Name",
          type: "string",
          sort: true,
          search: true,
          display: this.displayNameColumn,
        },
      ],
    };
  }

  protected addResourceButton = () => {
    return (
      <AnalysisForm
        {...this.props}
        trigger={
          <Button primary={true} positive={true}>
            Create Analysis
          </Button>
        }
      />
    );
  };

  public componentDidMount = () => {
    this.getData();
  };

  protected goToResource = (analysisId: string) => {
    this.props.history.push(routes.ANALYSIS(this.props.orgId, analysisId));
  };
}



// WEBPACK FOOTER //
// ./src/containers/Analyses/AnalysesTable.tsx